const REFRESH_TOKEN = 'refresh_token_center' // 刷新token存储本地对应的key
const REFRESH_TIME = 1000*60*30      // 刷新token的过期时间  30分钟 30*60*1000   8天 1000*60*60*24*8

export default {
  REFRESH_TOKEN,
  REFRESH_TIME
}



// WEBPACK FOOTER //
// ./src/utils/constant.js